import React, { useEffect, useState } from "react";
import { Grid, Typography } from "@material-ui/core";
import FormControl from "@material-ui/core/FormControl";
import { Controller } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { Tooltip } from "@material-ui/core";
import EquationEditor from "equation-editor-react";
import { IconButton } from "@material-ui/core";
import { FaInfoCircle } from "react-icons/fa";
import { CompactPicker, SketchPicker } from 'react-color';
import { Box } from '@material-ui/core';
import GridInputRow from "../../componentes/form-grids/GridInputRow";

const ColorPalletSketch = React.forwardRef((props, ref) => {
    const { t } = useTranslation();
    const [bordercolor, setBorderColor] = useState("");
    useEffect(() => {
        if (props.error === false) {
            setBorderColor("#FFFFFF")
        } else {
            setBorderColor("#FF0000")
        }

    }, [props.error]);

    return (
        <FormControl fullWidth ref={ref}>
            <Controller
                as={
                    <div>
                        <div>
                            <GridInputRow>
                                <Grid item xs={10}>
                                    <Typography>
                                        {props.translationString !== undefined
                                            ? t(props.translationString)
                                            : t(props.label)}
                                    </Typography>
                                </Grid>
                                {/* <Grid item xs={1}>
                      {props.hasFormula ? (
                        <>
                          <Tooltip
                            title={
                              <div
                                style={{
                                  fontSize: "14px",
                                }}
                              >
                                <EquationEditor
                                  value={props.lateXEquation}
                                  //onChange={setLatexEquation}
                                  autoCommands="pi theta sqrt sum prod alpha beta gamma rho"
                                  autoOperatorNames="sin cos tan"
                                />
                              </div>
                            }
                            style={{
                              padding: 1,
                              width: "20px",
                              height: "20px",
                            }}
                          >
                            <IconButton>
                              <FaInfoCircle color="#29438D" />
                            </IconButton>
                          </Tooltip>
                        </>
                      ) : null}
                    </Grid> */}
                            </GridInputRow>
                        </div>
                        <div>
                            <Box
                                border={2}
                                borderRadius={16}
                                style={{ padding: 6 }}
                                borderColor={bordercolor}
                                width="75%"
                                marginBottom="10px"
                            >
                                <SketchPicker
                                    defaultValue="#FFFFFF"
                                    color={props.colour}
                                    onChange={(event) => {
                                        props.onChange({
                                            ...event,
                                            target: { name: props.name, value: event.hex }
                                        });
                                    }}
                                />
                            </Box>
                        </div>
                    </div>
                }
                name={props.name}
                control={props.control}
                defaultValue={props.defaultValue}
            />
        </FormControl>
    );
});

export default ColorPalletSketch;
